export default __webpack_public_path__ + "static/media/arrow.e4763891.svg";